import { Text } from '@wartek-id/text-v1'

import type { FC } from 'react'
import type { TListDataItemValue } from 'app/KinerjaKSPage/components/CardDataConfirmation/utils/types'

type Props = {
  label: string
  children?: TListDataItemValue
}

export const DetailContentList: FC<Props> = ({ label, children }) => {
  return (
    <div className="grid grid-cols-12 gap-1">
      <Text color="subdued" className="col-span-4">
        {label}
      </Text>
      <div className="col-span-8 flex gap-4">{children}</div>
    </div>
  )
}
